<template>
  <el-form ref="form" size="mini" :model="form" class="bj-query-form bj-query-form-for-cal-height form" :rules="rules">
    <el-row :gutter="20" style="padding: 0 10px">
      <el-col :span="colSpan">
        <el-form-item :label="$t('billingPage.Client')" prop="clientCode">
          <BjSelectLov v-model="form.clientCode" :option-list="clientCodeList" :placeholder="$t('chooseText')" @change="getCategoryCodeList" />
        </el-form-item>
      </el-col>
      <el-col :span="colSpan">
        <el-form-item :label="$t('billingPage.Category')" prop="categoryCode">
          <BjSelectLov v-model="form.categoryCode" :option-list="categoryCodeList" :placeholder="$t('chooseText')" @change="clearValidator" />
        </el-form-item>
      </el-col>
      <el-col :span="colSpan">
        <el-form-item :label="$t('billingPage.quantity')" prop="quantity">
          <BjInputMoney v-model="form.quantity" :placeholder="$t('inputText')" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="colSpan">
        <el-form-item :label="$t('billingPage.PurchaseOrder')" prop="poId">
          <BjInput v-model="form.poId" :placeholder="$t('inputText')" clearable :disabled="poDIS" @change="poDISFUN" />
        </el-form-item>
      </el-col>
      <el-col :span="colSpan">
        <el-form-item :label="$t('billingPage.OrderNumber')" prop="orderId">
          <BjInput v-model="form.orderId" :placeholder="$t('inputText')" clearable :disabled="orderDIS" @change="orderDISFUN" />
        </el-form-item>
      </el-col>
      <el-col :span="colSpan">
        <el-form-item :label="$t('billingPage.ReturnOrder')" prop="returnOrderId">
          <BjInput v-model="form.returnOrderId" :placeholder="$t('inputText')" clearable :disabled="returnOrderDIS" @change="returnOrderDISFUN" />
        </el-form-item>
      </el-col>
      <el-col :span="colSpan">
        <el-form-item :label="$t('billingPage.yearAndWeek')" prop="year">
          <el-date-picker 
            id="getWeekDate" 
            v-model="weekDataNow" 
            :picker-options="{ firstDayOfWeek: 1 }"
            style="width: 100%" 
            type="week" 
            format="yyyy-WW" 
            :clearable="false" 
            :placeholder="$t('billingPage.yearAndWeeks')"
            @change="dataChange">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="colSpan">
        <el-form-item :label="$t('billingPage.invoiceNumber')" prop="invoiceId">
          <BjInput v-model="form.invoiceId" :placeholder="$t('inputText')" clearable :disabled="returnOrderDIS"  />
        </el-form-item>
      </el-col>
      <!-- LogisticRulesList： ['Freight_ALLI','Freight_AUSP','Freight_COMT'......] => logisticsBusinessName consignmentNo要必填-->
      <el-col :span="colSpan">
        <el-form-item :label="$t('billingPage.LogisticService')" prop="logisticsBusinessName" :rules="{ required:true, message: this.$t('chooseText'), trigger: 'change'}" v-if="LogisticRulesList.includes(form.categoryCode)">
          <BjSelectLov v-model="form.logisticsBusinessName" :option-list="LogisticsSelectionData" :placeholder="$t('chooseText')"/>
        </el-form-item>
        <el-form-item :label="$t('billingPage.LogisticService')" prop="logisticsBusinessName" :rules="{ required:false, message: this.$t('chooseText'), trigger: 'change'}" v-else>
          <BjSelectLov v-model="form.logisticsBusinessName" :option-list="LogisticsSelectionData" :placeholder="$t('chooseText')"/>
        </el-form-item>
      </el-col>
      <el-col :span="colSpan">
        <el-form-item :label="$t('billingPage.TrackingNo')" prop="consignmentNo" :rules="{ required:true, message: this.$t('inputText'), trigger: 'blur'}" v-if="LogisticRulesList.includes(form.categoryCode)">
          <BjInput v-model="form.consignmentNo" :placeholder="$t('inputText')" clearable/>
        </el-form-item>
        <el-form-item :label="$t('billingPage.TrackingNo')" prop="consignmentNo" :rules="{ required:false, message: this.$t('inputText'), trigger: 'blur'}" v-else>
          <BjInput v-model="form.consignmentNo" :placeholder="$t('inputText')" clearable/>
        </el-form-item>
      </el-col>
      <el-col :span="colSpan*2">
        <el-form-item :label="$t('billingPage.description')" prop="description">
          <BjInput v-model="form.description" type="textarea" autosize show-word-limit :maxlength="MAX_LENGTH.BILLMAX" :placeholder="$t('inputText')" />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { billApi,logisticApi } from '@/api';
import moment from 'moment';

export default {
  props: {
    clientCodeList: {
      type: Array,
      default: () => [],
    },
    categoryCodeList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      colSpan: 8,
      form: {
        clientCode: null,
        categoryCode: null,
        quantity: null,
        orderId: null,
        poId: null,
        returnOrderId: null,
        invoiceId: null,
        year: null,
        logisticsBusinessName: null,
        consignmentNo: null,
        description: null,
      },
      weekDataNow: new Date(),
      rules: {
        clientCode: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        categoryCode: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        quantity: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        year: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
      },
      poDIS: false,
      orderDIS: false,
      returnOrderDIS: false,
      // 物流列表信息
      LogisticsSelectionData: [],
      // 以下物流公司需要必填验证
      LogisticRulesList : [
        'Freight_ALLI','Freight_AUSP','Freight_COMT','Freight_COPL','Freight_Logistic','Freight_FWAY',
        'Freight_HUNT','Freight_MANUAL','Freight_AUSI','Freight_AUSX','Freight_AUEI','Freight_AUEP',
        'Freight_AUEX','Freight_AUIE','Freight_TNT','Freight_DIFE','Freight_DSTP','Freight_CAPT',
      ]
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    // 清空表单验证信息
    clearValidator(){
      this.$refs.form.clearValidate();
    },
    // 获取物流下拉信息
    async getLogisticsDataList() {
      logisticApi.getLogisticsBusiness({
          currentPage: 0,
          page: 0,
          pagesize: 999,
          size: 999,
        }).then(res => {
        this.LogisticsSelectionData = res.content.map(item => {
          return {
            label: item.logisticsName,
            value: item.name
          };
        });
      });
    },
    getCategoryCodeList(val) {
      billApi.getAllAdditionalCharges({clientCode: val}).then(res => {
        this.categoryCodeList = res.data;
      });
    },
    init() {
      this.getLogisticsDataList();
      this.poDIS = false;
      this.orderDIS = false;
      this.returnOrderDIS = false;
      this.form.year = document.querySelector('#getWeekDate').value;
    },
    dataChange(val) {
      const time = moment(val).format('YYYY-WW');
      this.form.year = time;
    },
    poDISFUN(e) {
      if (e) {
        this.orderDIS = true;
        this.returnOrderDIS = true;
      } else {
        this.orderDIS = false;
        this.returnOrderDIS = false;
      }
    },
    orderDISFUN(e) {
      if (e) {
        this.poDIS = true;
        this.returnOrderDIS = true;
      } else {
        this.poDIS = false;
        this.returnOrderDIS = false;
      }
    },
    returnOrderDISFUN(e) {
      if (e) {
        this.poDIS = true;
        this.orderDIS = true;
      } else {
        this.poDIS = false;
        this.orderDIS = false;
      }
    },
  }
};
</script>
